/**
 * Simple hook that provides translateCountry/translateCity functions.
 * Use in pages that display city/country names from the database.
 */
import { useCallback } from "react";
import { useTranslation } from "react-i18next";

export const useLocationTranslation = () => {
  const { t } = useTranslation();

  const translateCountry = useCallback(
    (name?: string | null) =>
      name && name.trim() ? t(`locations.countries.${name}`, { defaultValue: name }) : "",
    [t]
  );

  const translateCity = useCallback(
    (name?: string | null) =>
      name && name.trim() ? t(`locations.cities.${name}`, { defaultValue: name }) : "",
    [t]
  );

  return { translateCountry, translateCity };
};
